/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentTypeTimeslotsRequest } from './AppointmentTypeTimeslotsRequest';
import {
    AppointmentTypeTimeslotsRequestFromJSON,
    AppointmentTypeTimeslotsRequestFromJSONTyped,
    AppointmentTypeTimeslotsRequestToJSON,
    AppointmentTypeTimeslotsRequestToJSONTyped,
} from './AppointmentTypeTimeslotsRequest';

/**
 * Request for create a specific day model since new day model
 * @export
 * @interface SpecificDaySinceDayModelRequest
 */
export interface SpecificDaySinceDayModelRequest {
    /**
     * Name of the day model
     * @type {string}
     * @memberof SpecificDaySinceDayModelRequest
     */
    dayModelName?: string;
    /**
     * start of the special days period
     * @type {string}
     * @memberof SpecificDaySinceDayModelRequest
     */
    periodStart?: string;
    /**
     * end of the special days period
     * @type {string}
     * @memberof SpecificDaySinceDayModelRequest
     */
    periodEnd?: string;
    /**
     * 
     * @type {Array<AppointmentTypeTimeslotsRequest>}
     * @memberof SpecificDaySinceDayModelRequest
     */
    appointmentTypeTimeslots?: Array<AppointmentTypeTimeslotsRequest>;
}

/**
 * Check if a given object implements the SpecificDaySinceDayModelRequest interface.
 */
export function instanceOfSpecificDaySinceDayModelRequest(value: object): value is SpecificDaySinceDayModelRequest {
    return true;
}

export function SpecificDaySinceDayModelRequestFromJSON(json: any): SpecificDaySinceDayModelRequest {
    return SpecificDaySinceDayModelRequestFromJSONTyped(json, false);
}

export function SpecificDaySinceDayModelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecificDaySinceDayModelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dayModelName': json['dayModelName'] == null ? undefined : json['dayModelName'],
        'periodStart': json['periodStart'] == null ? undefined : json['periodStart'],
        'periodEnd': json['periodEnd'] == null ? undefined : json['periodEnd'],
        'appointmentTypeTimeslots': json['appointmentTypeTimeslots'] == null ? undefined : ((json['appointmentTypeTimeslots'] as Array<any>).map(AppointmentTypeTimeslotsRequestFromJSON)),
    };
}

export function SpecificDaySinceDayModelRequestToJSON(json: any): SpecificDaySinceDayModelRequest {
    return SpecificDaySinceDayModelRequestToJSONTyped(json, false);
}

export function SpecificDaySinceDayModelRequestToJSONTyped(value?: SpecificDaySinceDayModelRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dayModelName': value['dayModelName'],
        'periodStart': value['periodStart'],
        'periodEnd': value['periodEnd'],
        'appointmentTypeTimeslots': value['appointmentTypeTimeslots'] == null ? undefined : ((value['appointmentTypeTimeslots'] as Array<any>).map(AppointmentTypeTimeslotsRequestToJSON)),
    };
}

